import React, { useContext, useEffect, useState } from 'react'
import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { format, parse, startOfWeek, getDay } from 'date-fns'
import id from 'date-fns/locale/id'
import axios from '../../api/axios'
import Swal from 'sweetalert2'
import { AuthContext, ThemeContext } from '../../auth'

const locales = {
    'id': id
}

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
    locale: 'id'
})

function CalendarMeeting({ meetingIncoming }) {

    const { tokens } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const tokenUser = tokens?.token;

    const [ruangan, setRuangan] = useState([]);

    const retrieveRuangan = () => {
        axios.get(`/manage/ruangan/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setRuangan(res.data);

            }).catch(err => {
                console.error(err);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data pada server!',
                });
            })
    };

    useEffect(() => {
        if (tokenUser !== undefined) {
            retrieveRuangan();
        }
    }, [tokenUser]);

    const [dataCalendar, setDataCalendar] = useState([]);

    useEffect(() => {
        if (ruangan.length === 0) return;

        const meetingIncomingFilter = meetingIncoming.map(({ ...data }) => {
            const ruangan_name = ruangan.find((ruangan) => ruangan.id === data.ruangan);
            return {
                ...data,
                ruanganName: ruangan_name?.nama_ruangan,
            };
        });

        setDataCalendar(meetingIncomingFilter);
    }, [meetingIncoming, ruangan]);

    function parseToLocalDate(isoString) {
        const parts = isoString.split(/[-T:Z]/).map(Number)
        return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4])
    };

    function CustomEvent({ event }) {
        return (
            <div style={{ lineHeight: '1.2' }}>
                <div style={{ fontWeight: 600 }}>{event.title}</div>
                <div style={{ fontSize: '0.75rem', }}>{event.desc}</div>
            </div>
        )
    };

    function generatePastelColor(id) {
        const hue = (parseInt(id, 10) * 137) % 360
        return `hsl(${hue}, 70%, 85%)`
    };

    const eventStyleGetter = (event) => {
        const backgroundColor = generatePastelColor(event.id)
        return {
            style: {
                backgroundColor,
                border: 'none',
                color: '#222',
                borderRadius: '6px',
                padding: '4px',
            }
        }
    }

    const events = dataCalendar.map(meeting => ({
        id: meeting.id,
        title: meeting.nama_meeting,
        start: parseToLocalDate(meeting.waktu_mulai),
        end: parseToLocalDate(meeting.waktu_selesai),
        allDay: false,
        desc: meeting?.ruanganName || 'Tanpa Nama Ruangan',
    }))

    return (
        <div id={theme == "light" ? "containerAppDark" : "containerAppLight"} style={{ height: 750 }}>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                views={['month', 'day']}
                defaultView="month"
                tooltipAccessor="desc"
                components={{
                    event: CustomEvent,
                }}
                popup
                showMultiDayTimes={false}
                eventPropGetter={eventStyleGetter}
                style={{ height: 750 }}
            />
        </div>
    )
}

export default CalendarMeeting
